import type { TOC } from '@ember/component/template-only';

import AccountProgressPageComponent from 'webapp/components/account-progress/page';

const SettingsLevelRouteTemplate: TOC<object> = <template>
	<AccountProgressPageComponent />
</template>;

export default SettingsLevelRouteTemplate;
